var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oneid-callback"},[_c('div',{staticClass:"oneid-box"},[_c('b-spinner',{attrs:{"variant":"primary"}}),_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t("Loading") || "..."))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }